import { connect } from 'react-redux'

import NavigationHelper from 'layers/navigation/navigationHelper'
import withApiError from 'layers/errorHandling/apiError'
import { userSegmentationBuilder } from 'utils/userSegmentationHelpers'
import { resolveRouteServiceApp } from 'utils/routing/routeHelpers'

import { FlaggedRouteContentGetter as RouteContentGetter } from 'layers/content/v2/Hocs/FlaggedRouteContentGetter'

import Component from './component'

const mapStateToProps = state => {
  const { productManager } = state

  return {
    userSegmentationInfo: userSegmentationBuilder(state),
    productTabTitle: productManager?.productMap?.name || '',
  }
}

const navigationConnect = connect(
  NavigationHelper.mapStateToProps,
  NavigationHelper.mapDispatchToProps,
)
const loadingConnect = connect(mapStateToProps)

const options = {
  app: ({ route }) => resolveRouteServiceApp(route),
  routeResolver: () => window?.location?.pathname,
}

export default RouteContentGetter(
  withApiError(loadingConnect(navigationConnect(Component))),
  options,
)
